import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import './About.css'

const About = () => {
  const highlights = [
    { icon: '💼', title: 'Current Role', value: 'Technical Consultant @ Adobe' },
    { icon: '🏆', title: 'Certification', value: 'Adobe Certified Master (AEM)' },
    { icon: '🎓', title: 'Education', value: "Master's in Eng, Univ of South Florida" },
    { icon: '📍', title: 'Location', value: 'Dallas, Texas (Orig. Hyderabad)' }
  ]

  return (
    <div className="section-container">
      <Container>
        <h2 className="section-title">About Me</h2>
        
        {/* Quick Highlights Grid */}
        <div className="about-highlights-grid mb-5">
          {highlights.map((h, i) => (
            <div key={i} className="about-highlight-card">
              <span className="highlight-icon">{h.icon}</span>
              <div className="highlight-text">
                <span className="highlight-title">{h.title}</span>
                <span className="highlight-value">{h.value}</span>
              </div>
            </div>
          ))}
        </div>

        <Row className="align-items-center g-5">
          <Col xs={12} lg={4} className="text-center">
            <div className="about-photo-wrapper">
              <div className="photo-halo-glow" />
              <img
                className="about-photo"
                src={process.env.PUBLIC_URL + '/assets/images/profile.jpg'}
                alt="Nithin Dasyam"
                loading="lazy"
                decoding="async"
                width="240"
                height="240"
                onError={e => {
                  e.currentTarget.onerror = null
                  e.currentTarget.src = process.env.PUBLIC_URL + '/assets/images/logo512.jpeg'
                }}
              />
            </div>
            <div className="about-motto-badge mt-4">
              <em>&ldquo;The only way to do great work is to love what you do.&rdquo;</em>
              <div className="motto-author">&mdash; Steve Jobs</div>
            </div>
          </Col>

          <Col xs={12} lg={8}>
            <div className="about-content">
              <p className="about-lead-p">
                Greetings! I'm <strong>Nithin Dasyam</strong>, an enthusiastic technologist originally
                hailing from the vibrant city of Hyderabad, India, and currently rooted in the bustling
                metropolis of <strong>Dallas, Texas</strong>.
              </p>
              <p>
                With a strong academic foundation holding a Master's degree in
                Engineering from the esteemed University of South Florida, I've translated my
                educational prowess into an impactful career as a <strong>Technical Consultant at Adobe</strong>.
                Working in this dynamic enterprise environment allows me to continuously innovate, architecting
                robust enterprise web solutions. I take immense pride in being an <strong>Adobe Certified Master (AEM Sites Architect)</strong>,
                demonstrating rigorous dedication and technical excellence in high-scale content management systems.
              </p>
              <p>
                Beyond my professional pursuits, I thrive on an active lifestyle. Sports have always been
                a cornerstone of my routine—you'll often find me engaging in competitive matches of
                <strong> Pickleball</strong> and <strong>Basketball</strong>. When it's time to unwind,
                I enjoy exploring cinema storytelling, continually learning emerging technologies, and
                traveling across the globe to discover diverse cultures and perspectives.
              </p>
              <p>
                Whether you share my passion for technology, digital architecture, sports, or creative exploration,
                I'm always excited to connect, exchange ideas, and build meaningful partnerships!
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default About
